import type React from "react";

import type { KonvaEventObject } from "konva/lib/Node";

import type { DrawingState } from "../types";

import type { EditorAnnotation } from "../store/annotationTypes";

export interface AnnotationStrategyProps {
  screenToNormalized: (x: number, y: number) => { x: number; y: number };
  normalizedToScreen: (x: number, y: number) => { x: number; y: number };
  annotations: EditorAnnotation[];
  addAnnotation: (annotation: Omit<EditorAnnotation, "id">) => void;
  drawingState: DrawingState;
  drawingStateRef: React.RefObject<DrawingState>;
  setDrawingState: (state: DrawingState) => void;
  rectWidth: number;
  rectHeight: number;
}

export abstract class AnnotationStrategy {
  protected props: AnnotationStrategyProps;

  constructor(props: AnnotationStrategyProps) {
    this.props = props;
  }

  abstract handlePointerDown(e: KonvaEventObject<PointerEvent>): void;
  abstract handlePointerMove(e: KonvaEventObject<PointerEvent>): void;
  abstract handlePointerUp(e: KonvaEventObject<PointerEvent>): void;
  abstract getAnnotationType(): string;
}
